import { Column } from "@ant-design/plots";

const RevenueChart = ({ orders }) => {
  const data = orders.map((o) => ({
    order: o.id,
    revenue: JSON.parse(o.pricing).finalPrice,
  }));

  return <Column data={data} xField="order" yField="revenue" />;
};

export default RevenueChart;
